<template>
  <div :class="['ScreenBox', height === '0' ? 'flex' : '']" :style="{ height: height }">
    <div class="ScreenBox__header">
      <div class="title" @click="chartClick(menuCode)">
        {{ title }}
      </div>
    </div>
    <div class="ScreenBox__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import API from "../api/index";
import cacheKeys from "@/common/config/cacheKeys";
export default {
  name: "ScreenBoxClick",
  props: {
    title: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "0",
    },
    menuCode: {
      type: String,
      default: "",
    },
  },
  methods: {
    addMenuFromLeftNav(menu) {
      let tabList = this.$store.getters.menuTabsList || [];
      if (!this.isExist(tabList, menu)) {
        tabList.push(menu);
        if (tabList.length > 10) {
          tabList.splice(0, 1);
        }
        this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList);
      }
    },
    isExist(tabList, menu) {
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].code === menu.code || tabList[i].path === menu.path) return true;
      }
      return false;
    },
    chartClick(menuCode) {
      let menu = {}
      this.$fetch(API.checkMenuPath, {
        "menuCode": menuCode
      }).then((res) => {
        if (res.success) {
          if (res.returnObj != null) {
            menu = {
              code: res.returnObj.menuCode,
              name: res.returnObj.menuName,
              path: res.returnObj.path,
              activePath: res.returnObj.path
            }
            this.addMenuFromLeftNav(menu)
            this.$router.push(menu.path)
          } else {
            this.$message.warning("无此功能权限，请联系管理员");
          }
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.ScreenBox {
  width: 100%;
  display: flex;
  padding: 10px 30px 10px 30px;
  flex-direction: column;
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;

  &.flex {
    flex: 1;
  }

  &__header {
    height: 40px;
    font-size: 18px;
    width: 100%;
    color: #ffffff;
    background: url("~@src/common/assets/images/screen/titleLine.png") left bottom no-repeat;

    .title {
      font-family: YouSheBiaoTiHei-Bold;
      font-size: 28px;
      padding: 5px 0 0 0;
      cursor: pointer;
    }

    .title:hover {
      color: #409EFF;
    }

    .border {
      width: 100%;
      display: inline-block;
      flex: 1;
      margin-left: 14px;
      height: 31px;
    }
  }

  &__body {
    flex: 1;
    height: 0;
    padding-top: 10px;
  }
}
</style>




